import angular from 'angular';

// TODO: PK Test this out. Will this element be appended to the body or do we need to move this script out somewhere else?
/* Disable the validation error when the dateInput is invalid */
angular
  .element(document.getElementsByTagName('BODY')[0])
  .append(
    angular.element('<style> .dateError.csmInvalid { border: none }</style>')
  );

/**
 * @ngdoc    directive
 * @name     csm.ui.validators.directive:dateValidator
 * @restrict A
 * @param    {string=} csmRequired      "false"=value is not required.
 * @param    {string=} dateValidator    Error popup title.
 * @param    {string=} disableValidator "true"=skip validation.
 * @param    {string=} maxDate          Maximum date limitation.
 * @param    {string=} minDate          Mininum date limitation.
 *
 * @description
 * Validator to verify a date value. Works with the `dateInput` directive.
 **/
/* @ngInject */ export function dateValidator($injector, CSMValidatorService) {
  return CSMValidatorService.makeDirective({
    doValidate: $injector.invoke(doValidate),
    require: { dateInput: '?dateInput' },
    link: function (scope, elem, attr, ctrl, val) {
      /*-----------------------------------------------------------*/
      /* If a dateInput is found, the doValidate method needs to   */
      /* be extended to check for the component validation as well */
      /*-----------------------------------------------------------*/
      if (ctrl.dateInput) {
        var baseDoValidate = val.doValidate;
        val.doValidate = function (value) {
          var error = baseDoValidate.call(this, value);

          if (!error && !ctrl.dateInput.isValid()) error = 'Not a valid date';

          return error;
        };
      }
    }
  });
}

/* @ngInject */
function doValidate($filter, CSMValidatorService) {
  return function (value) {
    var FMT_DATE_DISPLAY = 'MM/dd/yyyy'; // Date Display Format.
    var REG_EX_DATE = /^\d{1,2}\/\d{1,2}\/\d{4}$/; // Date Reg Ex for MM/DD/YYYY.
    /*--------------------------*/
    /* Check for required value */
    /*--------------------------*/
    var reqError = CSMValidatorService.BaseValidator.prototype.doValidate.call(
      this,
      value
    );
    if (reqError) return reqError;

    /*-----------------------------*/
    /* Process if there is a value */
    /*-----------------------------*/
    if (value) {
      /*-----------------------*/
      /* Check for date object */
      /*-----------------------*/
      var date = new Date(value);
      if (
        (angular.isString(value) && !REG_EX_DATE.test(value)) ||
        date == 'Invalid Date'
      )
        return 'Not a valid date';

      /*---------------------------------*/
      /* Check for a minimum date if set */
      /*---------------------------------*/
      if (
        this.attributes.minDate != undefined &&
        REG_EX_DATE.test(this.attributes.minDate)
      ) {
        var minDate = new Date(this.attributes.minDate);
        if (date < minDate)
          return 'Date cannot be before {0}'.format(
            $filter('date')(minDate, FMT_DATE_DISPLAY)
          );
      }

      /*---------------------------------*/
      /* Check for a maximum date if set */
      /*---------------------------------*/
      if (
        this.attributes.maxDate != undefined &&
        REG_EX_DATE.test(this.attributes.maxDate)
      ) {
        /*-------------------------------------------------*/
        /* Add a day and subtract a millisecond to make    */
        /* it the max allowable time for the provided date */
        /*-------------------------------------------------*/
        var maxDate = new Date(this.attributes.maxDate);
        var compareDate = new Date(maxDate.getTime() + 1000 * 60 * 60 * 24 - 1);
        if (date > compareDate)
          return 'Date cannot be after {0}'.format(
            $filter('date')(maxDate, FMT_DATE_DISPLAY)
          );
      }
    }

    /*-------------------*/
    /* No problems found */
    /*-------------------*/
    return null;
  };
}
